import React from "react";
import { ApexOptions } from "apexcharts";
import ReactApexCharts from "react-apexcharts";
import { useStyles } from "./PieChartComponent.styles";
import { COLORS } from "config/theme/baseTheme";

interface PieChartProps {
    options?: ApexOptions;
    pieData: any;
    pieLabel?: any;
    pieColors: any;
    title: any;
}

const PieChart = (props: PieChartProps) => {
    const { pieData, pieLabel, pieColors, title } = props;
    const classes = useStyles();
    const config: any = {
        series: pieData,
        options: {
            chart: {
                fontFamily: "Montserrat",
                type: "pie",
                style: {
                    padding: "24px"
                }
            },
            chartOptions: {
                labels: pieLabel
            },
            title: {
                text: title,
                style: {
                    fontSize: 16,
                    fontWeight: 600,
                    fontFamily: "Montserrat",
                    color: COLORS.BLACK,
                    lineHeight: "20px",
                    padding: "24px"
                }
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: "60%",
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                offsetY: 20
                            },
                            value: {
                                show: true,
                                fontSize: 24,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: COLORS.BLACK,
                                offsetY: -20,
                            },
                        },
                    },
                },
            },
            colors: pieColors,
            labels: pieLabel,
            dataLabels: {
                dropShadow: {
                    enabled: false
                },
            },
            legend: {
                floating: false,
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                fontFamily: "Montserrat",
                fontSize: 12,
                fontWeight: 500,
            },
            stroke: { width: 0 },
            noData: {
                text: "No Data Available",
                style: {
                    fontFamily: "Montserrat",
                    fontSize: 14,
                    colors: ["#000000"],
                    fontWeight: 500,
                },
                verticalAlign: "middle"
            },
            tooltip:
            {
                onDatasetHover: {
                    highlightDataSeries: true
                }
            },
        }
    };


    return (
        <>
            <div id="chart" className={classes.dashboardChartStyle}>
                <ReactApexCharts options={config.options} series={config.series} type="pie" height="350px" />
            </div>
        </>
    );
};


export default PieChart;
